module.exports = __webpack_public_path__ + "static/painscale-img-3e95da3f705f00491a0f006068a2125f.png";